const selectedVacanciesScriptsEntries = new Map([
  ['m-yasnik-na-fabriku-m-yasa-40025', `(function(h,o,t,j,a,r){ h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)}; h._hjSettings={hjid:2612307,hjsv:6}; a=o.getElementsByTagName('head')[0]; r=o.createElement('script');r.async=1; r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv; a.appendChild(r); })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`],
  ['zabiynik-na-fabriku-m-yasa-93104', `(function(h,o,t,j,a,r){ h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)}; h._hjSettings={hjid:2612397,hjsv:6}; a=o.getElementsByTagName('head')[0]; r=o.createElement('script');r.async=1; r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv; a.appendChild(r); })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`],
]);

const vacancyHotyarScriptId = 'vacancy-hotjar-script';

export function bindCustomHotjars(to, from) {
  // Temporary disabled Hotjar, setup on server side (PHP backend)
  const temporaryDisabled = true;
  if (temporaryDisabled) return;

  // For vacancy page
  if (to.name === 'vacancy-double' || from.name === 'vacancy-double') {
    if (to.params.vacancyId === from.params.vacancyId) return;

    if (selectedVacanciesScriptsEntries.has(from.params.vacancyId)) {
      removeScriptById(from.params.vacancyId);
    }

    if (selectedVacanciesScriptsEntries.has(to.params.vacancyId)) {
      integrateScriptByVacancyId(vacancyHotyarScriptId);
    }
  }
}

function integrateScriptByVacancyId(id) {
  const scriptContent = selectedVacanciesScriptsEntries.get(id);
  const script = document.createElement('script');
  script.id = vacancyHotyarScriptId;
  script.innerText = scriptContent;
  document.head.appendChild(script);
}

function removeScriptById() {
  const script = document.getElementById(vacancyHotyarScriptId);
  if (script) script.remove();
}
